<app-menu class="menuApp" xmlns="http://www.w3.org/1999/html"></app-menu>
<div class="main">

  <div class="row upperRow">
    <div class="col-8">
      <div class="row" style="width: 95%; margin: auto auto 2vh; height: 6vh;">

        <div class="col-4" style="display: flex">
          <div (click)="goToSelectPlano()" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">arrow_back</span>
          </div>

          <div (click)="zoom(-1)" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">zoom_out</span>
          </div>

          <div (click)="zoom(1)" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">zoom_in</span>
          </div>

          <div [ngClass]="{upperButtonActive: movePlano}" (click)="changeMovePlano()" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">open_with</span>
          </div>

          <div (click)="returnMovePlano()" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">zoom_out_map</span>
          </div>

          <div (click)="openOptions()" class="upperButton">
            <span class="material-icons-outlined spanIcon textS+">more_horiz</span>
          </div>
        </div>

        <div class="col-8" style="text-align: center">
          <h3 class="marginAuto centerVert textM">{{planoService.getPlanoSelected().nombre}}</h3>
        </div>
      </div>
      <div class="map">
        <canvas #elementsBackground class="elementsBackgroundCanvas" (mousedown)="start($event)"
                (mousemove)="move($event)" (mouseup)="end()" (wheel)="wheelEvent($event)"
                oncontextmenu="return false;"></canvas>
        <canvas #background class="backgroundCanvas"></canvas>
      </div>

      <!-- INFO SELECTED LUMINAIRE -->
      <div class="container infoSelectedLum" *ngIf="this.selectedLum">

        <div class="row" style="margin-left: 0; margin-bottom: 2vh;">

          <div class="col-5">
            <div class="row" style="margin: auto">
              <h5 class="textS">
                ID: <b>{{this.selectedLum.idDispositivo}}</b>
              </h5>
            </div>

            <div class="row" style="margin: auto">
              <h5 class="textS">
                {{this.localiser.get("floorplans.name")}}: <b>{{this.selectedLum.nombre}}</b>
              </h5>
            </div>
            <div class="row" style="margin: auto">
              <h5 *ngIf="getZonaOfLuminaria(this.selectedLum) != undefined" class="textS">
                {{this.localiser.get("floorplans.zona")}}: <b>{{getZonaOfLuminaria(this.selectedLum).nombre}}</b>
              </h5>
              <h5 *ngIf="getZonaOfLuminaria(this.selectedLum) == undefined" class="textS">
                {{this.localiser.get("floorplans.zona")}}: <b>--</b>
              </h5>
            </div>
            <div class="row" style="margin: auto">
              <h5 class="textS">{{this.localiser.get("devices.modelLed")}}:</h5>
              <mat-select
                [(ngModel)]="modelLuminariaSelected"
                (selectionChange)="changeModelLuminaria($event.value)"
                style="width: 70%; margin: auto;"
              >
                <mat-option class="textS" *ngFor="let model of getModelList()" [value]="model">
                  {{ model.id }}
                </mat-option>
              </mat-select>

            </div>
          </div>

          <div class="col-4 textS">
            <!-- Has emergency module -->
            <div class="row" style="margin: auto">
              {{this.localiser.get("floorplans.hasEmergency")}}:&nbsp;<b>{{checkPeripheralLum(this.selectedLum, "emg")}}</b>
            </div>
            <div class="row" style="margin: auto">
              {{this.localiser.get("floorplans.hasPresence")}}:&nbsp;<b>{{checkPeripheralLum(this.selectedLum, "presence")}}</b>
            </div>
            <div class="row" style="margin: auto">
              {{this.localiser.get("floorplans.has420Sensor")}}:&nbsp;<b>{{checkPeripheralLum(this.selectedLum, "420")}}</b>
            </div>
            <div class="row" style="margin: auto">
              <button class="custom-btn btn textS" (click)="resetPosicionLuminaria()">
                {{this.localiser.get("floorplans.resetPos")}}
              </button>
            </div>
          </div>

          <div class="col-3">
            <div class="row" style="margin: auto">
              <div class="col-6" style="margin: auto">
                <input class="textS" style="width: 100%" [(ngModel)]="argBlinkLuminaria" (input)="maxLengthCheckBlink($event)" type="number" max="100">
              </div>
              <div class="col-6" style="padding: 0">
                <button class="custom-btn btn textS" (click)="blinkLuminaire()">
                  {{this.localiser.get("floorplans.blink")}}
                </button>
              </div>
            </div>
            <div class="row" style="margin: auto">
              <div class="col-6" style="margin: auto">
                <input class="textS" style="width: 100%" [(ngModel)]="argPowerLuminaria" (input)="maxLengthCheckPower($event)" type="number" max="100">
              </div>
              <div class="col-6" style="padding: 0">
                <button class="custom-btn btn textS" (click)="powerLuminaire()">
                  {{this.localiser.get("floorplans.power")}}
                </button>
              </div>
              <div class="col-6" style="margin: auto">
              </div>
              <div class="col-6" style="padding: 0">
                <button class="custom-btn btn textS" (click)="updateRotacion()">
                  {{this.localiser.get("floorplans.rotate")}}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- INFO FLOORPLAN AND SCALE -->
      <div class="row" style="margin: 1% auto; width: 100%">
        <div class="col-5" style="margin: auto; border-right: 1px solid #18264f;">
          <div class="row" style="margin: auto">
            <h3 class="textS">{{this.localiser.get("floorplans.lengthText")}}</h3>
          </div>
          <div class="row">
            <div class="col">
              <input [(ngModel)]="planoSelected.metrosPlano" placeholder="{{this.localiser.get('floorplans.meters')}}"
                     type="number" class="inputText textS" maxlength="10"
                     style="margin: auto">
            </div>
            <div class="col" style="margin: auto">
              <h3 class="textS" style="margin: auto">{{this.localiser.get("floorplans.meters")}}</h3>
            </div>
          </div>
        </div>
        <div class="col-5" style="margin: auto">
          <div class="row" style="margin: auto">
            <h3 class="textS">{{this.localiser.get("floorplans.scaleText")}}</h3>
          </div>
          <div class="row">
            <div class="col-3" style="margin: auto; text-align: right">
              <h3 class="textS" style="margin: auto">1:</h3>
            </div>
            <div class="col">
              <input [(ngModel)]="planoSelected.escalaLuminarias" placeholder="{{this.localiser.get('floorplans.scale')}}"
                     type="number" class="inputEscala textS" maxlength="3"
                     style="margin: auto">
            </div>
          </div>
        </div>
        <div class="col-2" style="margin: auto">
          <div class="row" style="margin: auto">
            <button class="customButtonColorReverse textS" mat-button
                    style="border: 1px solid white" (click)="updatePlano()">{{this.localiser.get("button.update")}}</button>
          </div>
        </div>
      </div>

    </div>

    <!-- RIGHT COL - LIST -->
    <div class="col-4 luminariasList">

      <!-- LUMINAIRE LIST -->
      <h4 style="text-decoration: underline">
        {{this.localiser.get("floorplans.lumList")}}
      </h4>
      <div class="luminariasListScroll">

        <!-- SEARCHER -->
        <div class="row searcherDiv">
          <div class="col-10">
            <input [(ngModel)]="searcherLuminarias" type="text" class="centerVert textS searcherInput"
                   placeholder="{{this.localiser.get('devices.searcher')}}" (input)="searcherLuminariasFunc()" maxlength="50">
          </div>

          <div class="col-2" style="margin: inherit">
            <span class="material-icons-outlined textXXM centerVert">
              search
            </span>
          </div>
        </div>

        <div *ngFor="let luminaria of this.luminarias; index as i" class="luminariaBox">
          <div (click)="selectLum(luminaria)" class="luminariaRow col-10"
               [ngClass]="{'selectedRow': this.selectedLum == luminaria}">
            <h6 class="textS" style="text-decoration: underline; margin: 1% auto"><b>{{luminaria.nombre}}</b></h6>
            <h6 class="textS" style="margin: 1% auto">{{luminaria.idDispositivo}}</h6>
          </div>

          <div *ngIf="user.getPermiso() != 'Ateneo'" (click)="goToInfoLuminaria(luminaria)" class="col-2">
            <span class="material-icons-outlined buttonMapInfo textXM centerVert">
                info
            </span>
          </div>
        </div>
      </div>


    </div>
  </div>


</div>
